// material-ui
import { Box } from "@mui/material";

// project import
import NavGroup from "./NavGroup";
import NavItem from "./NavItem";
import useDrawerMenu from "@/useHooks/useDrawerMenu";

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {

  const [menu] = useDrawerMenu();


  const navGroups = menu.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} items={item} />;
      default:
        return (
          <NavItem key={item.id} item={item} level={1} isGroupItem={true} />
        );
    }
  });

  return <Box sx={{ pt: 1 }}>{navGroups}</Box>;
};

export default Navigation;
